import React from 'react';
import { styled } from '@linaria/react';
import { ITheme, useTheme } from 'src/theme';

const TagElement = styled.div<TagProps>`
background-color: ${props => props.variant === 'promo' ? props.theme?.colors.secondary || '' : props.theme?.colors.grey[600] || ''};
border-radius: ${props => props.variant === 'promo' ? '2px' : '4px'};
border: ${props => props.variant === 'promo' ? 'none' : `1px solid ${props.theme?.colors.grey[600] || ''}`};
box-shadow: ${props => props.variant === 'promo' ? 'none' : '0px 2px 4px 0px rgba(0,0,0,0.05)'};
-webkit-box-shadow: ${props => props.variant === 'promo' ? 'none' : '0px 2px 4px 0px rgba(0,0,0,0.05)'};
color: ${props => props.variant === 'promo' ? props.theme.colors.white : props.theme.colors.primary};
  cursor: ${props => props.disabled ? 'default'
    : (props.variant === 'default' ? 'pointer' : 'default') };
  display: inline-block;
  font-size: ${props => props.variant === 'promo' ? '12px' : '14px'};
  font-family: ${props => props.theme.fontFamily};
  font-weight: ${props => props.variant === 'promo' ? 'bold' : 'normal'};
  line-height: ${props => props.variant === 'promo' ? '18px' : '20px'};
  margin: ${props => typeof props.margin === 'number' ? `${props.margin}px` : props.margin};
  padding: ${props => props.variant === 'promo' ? '1px 6px 0 6px' : '4px 10px 4px 10px'};
  text-transform: ${props => props.variant === 'promo' ? 'uppercase' : 'none'};
  user-select: none; -webkit-user-select: none; -webkit-touch-callout: none;
  opacity: ${props => props.disabled ? '0.3' : '1'};
`;

export interface TagProps {
  variant?: 'default' | 'promo';
  theme?: any;
  disabled?: boolean;
  children?: React.ReactNode;
  margin: string | number;
  callback?: (name: any) => void;
  className?: string;
}

function Tag({
  variant,
  disabled,
  children,
  margin,
  className,
  callback = (name: any) => {},
}: TagProps) {

  const handleClick = (event: any): void => {
    if (variant === 'default' && !disabled) {
      console.debug(`Tag handleClick: ${event}`, event);
      if (callback) {
        callback(children);
      }
    }
  }
  const theme: ITheme = useTheme();
  return <TagElement className={className} margin={margin} theme={theme} variant={variant} onClick={handleClick} disabled={disabled}>
    {children}
  </TagElement>;
};

Tag.defaultProps = {
  variant: 'default',
  disabled: false,
  margin: 0
}

export default Tag;
